import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss']
})
export class AccessComponent implements OnInit {

    errorMsg: string;
    loading = false;
    companyname: string;
    firstname: string;
    lastname: string;
    emailaddress: string;
    phonenumber: string;
    gToken: string;

    screenHeight: number;

    phoneNoPattern = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    emailPattern = /.+@.+\..+/;

    constructor(public router: Router, private userService: UserService,private recaptchaV3Service: ReCaptchaV3Service) { }

    ngOnInit(): void {
        this.screenHeight = window.innerHeight;
            
     this.captcha_execute();     
     setInterval(() => 
     {   
        this.captcha_execute();
    }, 90 * 1000);
    
}
    

    captcha_execute = () =>  {
        this.recaptchaV3Service.execute('contactus')
        .subscribe((token) => { this.gToken = token;
        });
    };

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.screenHeight = event.target.innerHeight;
    }

    

    submitAccessReq = () => {
        this.loading = true;
        this.userService.requestAccess({
            companyname: this.companyname, firstname: this.firstname,
            lastname: this.lastname, emailaddress: this.emailaddress, phonenumber: this.phonenumber,
            reCaptchaCode:this.gToken
        }).subscribe(res => {
            alert('Your MyVista account request has been forwarded to iWorkGlobal for review.');
            this.loading = false;
            this.router.navigate(['login']);
        },
        err=>{
          console.log("Err :: ",err);
          this.loading = false;
        });
    }

}
